/*
 * YWM Price Slider
 * Wraps Dawn's price-facet with a noUiSlider dual-handle slider.
 * The slider writes whole-dollar values into Dawn's existing min/max inputs
 * and triggers their input event, letting Dawn's facet-filters-form handle
 * the debounced form submission.
 *
 * Requires noUiSlider 15.x to be loaded before this script.
 */
(function () {
  'use strict';

  // Locales that use comma decimals — match Dawn's price-facet logic
  var COMMA_DECIMAL_CURRENCIES = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND';

  function getCurrencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function usesCommaDecimals() {
    return COMMA_DECIMAL_CURRENCIES.indexOf(getCurrencyCode()) !== -1;
  }

  // Round to nearest whole unit (dollar) for the inputs
  function formatForInput(num) {
    var rounded = String(Math.round(num));
    // No decimal separator needed for whole numbers, but kept for consistency
    return rounded;
  }

  function parseFromInput(str) {
    if (!str) return null;
    // Normalize comma decimal back to dot for parseFloat
    var normalized = String(str).replace(',', '.');
    var num = parseFloat(normalized);
    return isNaN(num) ? null : num;
  }

  // Currency formatter used by the screen-reader announcement of slider values
  function formatCurrency(num) {
    var code = getCurrencyCode();
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        maximumFractionDigits: 0
      }).format(Math.round(num));
    } catch (e) {
      // Fallback if Intl isn't available or the currency code is rejected
      return '$' + Math.round(num);
    }
  }

  // Apply accessible names to the noUiSlider handles after creation.
  // noUiSlider gives the handles role="slider" automatically but no name.
  function labelSliderHandles(sliderEl) {
    var lower = sliderEl.querySelector('.noUi-handle-lower');
    var upper = sliderEl.querySelector('.noUi-handle-upper');
    if (lower) {
      lower.setAttribute('aria-label', 'Minimum price');
    }
    if (upper) {
      upper.setAttribute('aria-label', 'Maximum price');
    }
  }

  function initSlider(sliderEl) {
    if (sliderEl.dataset.ywmInit === 'true') return;
    if (typeof noUiSlider === 'undefined') {
      console.warn('[YWM Price Slider] noUiSlider library not loaded — slider will not render.');
      return;
    }

    var rangeMin = parseFloat(sliderEl.dataset.rangeMin) || 0;
    var rangeMax = parseFloat(sliderEl.dataset.rangeMax) || 1000;
    if (rangeMax <= rangeMin) rangeMax = rangeMin + 1;

    // Use getElementById to safely handle IDs with spaces, emoji, or other special chars
    var minInput = document.getElementById(sliderEl.dataset.inputMinId);
    var maxInput = document.getElementById(sliderEl.dataset.inputMaxId);
    if (!minInput || !maxInput) {
      console.warn('[YWM Price Slider] Could not find inputs by ID:', sliderEl.dataset.inputMinId, sliderEl.dataset.inputMaxId);
      return;
    }

    var startMin = parseFromInput(minInput.value);
    var startMax = parseFromInput(maxInput.value);
    if (startMin === null || startMin < rangeMin) startMin = rangeMin;
    if (startMax === null || startMax > rangeMax) startMax = rangeMax;

    noUiSlider.create(sliderEl, {
      start: [startMin, startMax],
      connect: true,
      range: { min: rangeMin, max: rangeMax },
      step: 1,
      // Accessible value text for screen readers — read instead of the raw number.
      // Returns a formatted currency string so screen readers say "$1,200" not "1200.00".
      ariaFormat: {
        to: function (value) {
          return formatCurrency(value);
        },
        from: function (value) {
          return parseFromInput(String(value).replace(/[^0-9.,-]/g, ''));
        }
      }
    });

    // Apply accessible names to the handles right after noUiSlider creates them
    labelSliderHandles(sliderEl);

    // Slider drag → update input values (visual only; no submit during drag)
    sliderEl.noUiSlider.on('update', function (values) {
      var minVal = parseFloat(values[0]);
      var maxVal = parseFloat(values[1]);
      // Mirror Dawn's behavior: blank the input if it's at the range edge
      minInput.value = minVal <= rangeMin ? '' : formatForInput(minVal);
      maxInput.value = maxVal >= rangeMax ? '' : formatForInput(maxVal);
    });

    // Slider released → fire input event so Dawn's facet-filters-form submits the form
    sliderEl.noUiSlider.on('change', function () {
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Typing in inputs → move the slider handles (visual sync)
    function syncSliderFromInputs() {
      var newMin = parseFromInput(minInput.value);
      var newMax = parseFromInput(maxInput.value);
      if (newMin === null) newMin = rangeMin;
      if (newMax === null) newMax = rangeMax;
      sliderEl.noUiSlider.set([newMin, newMax]);
    }
    minInput.addEventListener('change', syncSliderFromInputs);
    maxInput.addEventListener('change', syncSliderFromInputs);

    sliderEl.dataset.ywmInit = 'true';
  }

  function initAll() {
    var sliders = document.querySelectorAll('[data-ywm-price-slider]');
    for (var i = 0; i < sliders.length; i++) {
      initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Watch for Dawn AJAX re-renders of the facets HTML
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-ywm-price-slider]')) {
          initSlider(node);
        } else if (node.querySelectorAll) {
          var nested = node.querySelectorAll('[data-ywm-price-slider]');
          for (var k = 0; k < nested.length; k++) {
            initSlider(nested[k]);
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', initAll);
})();